import React, { Component } from 'react';
import parse from 'html-react-parser';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { fade, Modal, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';

import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
//import Calendar from './index';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import { KeyboardTimePicker, KeyboardDatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import { getMyDate, getMyDate2 } from '../../../@jumbo/utils/commonHelper';
import MenuItem from '@material-ui/core/MenuItem';
const useStyles = theme => ({
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 200,
  },
  boxTop: {
    paddingTop: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  myButton: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },

  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  '@media screen and (max-width: 800px)': {
    width: '95%',
  },
  '@media screen and (min-width: 800px)': {
    width: 600,
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const DialogTitle = withStyles(useStyles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
}))(MuiDialogActions);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class ViewEvent extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.handleClick = this.handleClick.bind(this);
    this.state = {
      data: {},
      rows: [],
      startTime1: '',
      endTime1: '',
      startDate1: '',
      endDate1: '',
      type: 0,
    };
  }
  handleClickOpen() {
    //  setOpen(true);
  }
  handleChange(name, value) {
    if (value == null) return;
    this.setState({ [name]: value }, () => {
      //   this.updateRooms();
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selData !== this.props.selData) {
      this.setState({ startDate1: this.props.selData.date1 });
      this.setState({ startTime1: this.props.selData.time1 });
      this.setState({ endDate1: this.props.selData.date2 });
      this.setState({ endTime1: this.props.selData.time2 });
      this.setState({ osoba: this.props.selData.osoba });
      this.setState({ type: this.props.selData.type });
      /*      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'getClient',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.props.resId,
        },
      };
      //    console.log('pms');
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      //      console.log(pmsUrl);
      if (pmsUrl == '') return;
      var mode = this.props.auth.authUser.clouduser;
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (res.data.Data != null) {
          this.setState({
            firstName: res.data.Data.firstName,
            lastName: res.data.Data.lastName,
            birthDate: res.data.Data.birthDate,
            company: res.data.Data.company,
            address1: res.data.Data.address1,
            address2: res.data.Data.address2,
            city: res.data.Data.city,
            country: res.data.Data.country,
            phone: res.data.Data.phone,
            fax: res.data.Data.fax,
            email: res.data.Data.email,
            ordersCount: res.data.Data.ordersCount,
          });
        }
      });*/
    }
  }

  handleClose() {
    this.props.setState({ viewEventVisible: false });
    //  setOpen(false);
  }

  handleSave() {
    const senddata = {
      Action: 'move_shift',
      Data: {
        Id: this.props.Id,
        fromTime: this.state.startDate1 + ' ' + this.state.startTime1,
        toTime: this.state.endDate1 + ' ' + this.state.endTime1,
        Type: this.state.type,
      },
    };

    //var pmsUrl = this.props.auth.authUser.pmsUrl;
    var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
    this.setState({ running2: true });
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      this.props.doRefresh();
      this.props.setState({ viewEventVisible: false });
    });
    //  setOpen(false);
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.handleClose}
          anchorEl={this.props.anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}>
          <Box sx={style}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box ml={6} fontSize={12}>
                  Osoba:
                </Box>
                <Box ml={6}>{this.state.osoba}</Box>
              </Grid>

              <Grid item xs={12}>
                <Box ml={6} fontSize={12}>
                  Početak:
                </Box>
                <Box ml={6}>
                  <Box className={classes.columnRoot}>
                    {getMyDate2(this.state.startDate1, 'hr')}{' '}
                    <TextField
                      id="viewMode"
                      name="viewMode"
                      margin="small"
                      select
                      defaultValue=""
                      value={this.state.startTime1}
                      style={{ marginLeft: 20 }}
                      onChange={event => this.handleChange('startTime1', event.target.value)}>
                      <MenuItem value={'06:00'}>6:00</MenuItem>
                      <MenuItem value={'06:30'}>6:30</MenuItem>
                      <MenuItem value={'07:00'}>7:00</MenuItem>
                      <MenuItem value={'07:30'}>7:30</MenuItem>
                      <MenuItem value={'08:00'}>8:00</MenuItem>
                      <MenuItem value={'08:30'}>8:30</MenuItem>
                      <MenuItem value={'09:00'}>9:00</MenuItem>
                      <MenuItem value={'09:30'}>9:30</MenuItem>
                      <MenuItem value={'10:00'}>10:00</MenuItem>
                      <MenuItem value={'10:30'}>10:30</MenuItem>
                      <MenuItem value={'11:00'}>11:00</MenuItem>
                      <MenuItem value={'11:30'}>11:30</MenuItem>
                      <MenuItem value={'12:00'}>12:00</MenuItem>
                      <MenuItem value={'12:30'}>12:30</MenuItem>
                      <MenuItem value={'13:00'}>13:00</MenuItem>
                      <MenuItem value={'13:30'}>13:30</MenuItem>
                      <MenuItem value={'14:00'}>14:00</MenuItem>
                      <MenuItem value={'14:30'}>14:30</MenuItem>
                      <MenuItem value={'15:00'}>15:00</MenuItem>
                      <MenuItem value={'15:30'}>15:30</MenuItem>
                      <MenuItem value={'16:00'}>16:00</MenuItem>
                      <MenuItem value={'16:30'}>16:30</MenuItem>
                      <MenuItem value={'17:00'}>17:00</MenuItem>
                      <MenuItem value={'17:30'}>17:30</MenuItem>
                      <MenuItem value={'18:00'}>18:00</MenuItem>
                      <MenuItem value={'18:30'}>18:30</MenuItem>
                      <MenuItem value={'19:00'}>19:00</MenuItem>
                      <MenuItem value={'19:30'}>19:30</MenuItem>
                      <MenuItem value={'20:00'}>20:00</MenuItem>
                      <MenuItem value={'20:30'}>20:30</MenuItem>
                      <MenuItem value={'21:00'}>21:00</MenuItem>
                      <MenuItem value={'21:30'}>21:30</MenuItem>
                      <MenuItem value={'22:00'}>22:00</MenuItem>
                      <MenuItem value={'22:30'}>22:30</MenuItem>
                      <MenuItem value={'23:00'}>23:00</MenuItem>
                      <MenuItem value={'23:30'}>23:30</MenuItem>
                    </TextField>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box ml={6} fontSize={12}>
                  Kraj:
                </Box>
                <Box ml={6}>
                  <Box className={classes.columnRoot}>
                    {getMyDate2(this.state.endDate1, 'hr')}{' '}
                    <TextField
                      id="viewMode"
                      name="viewMode"
                      margin="small"
                      select
                      defaultValue=""
                      value={this.state.endTime1}
                      style={{ marginLeft: 20 }}
                      onChange={event => this.handleChange('endTime1', event.target.value)}>
                      <MenuItem value={'06:00'}>6:00</MenuItem>
                      <MenuItem value={'06:30'}>6:30</MenuItem>
                      <MenuItem value={'07:00'}>7:00</MenuItem>
                      <MenuItem value={'07:30'}>7:30</MenuItem>
                      <MenuItem value={'08:00'}>8:00</MenuItem>
                      <MenuItem value={'08:30'}>8:30</MenuItem>
                      <MenuItem value={'09:00'}>9:00</MenuItem>
                      <MenuItem value={'09:30'}>9:30</MenuItem>
                      <MenuItem value={'10:00'}>10:00</MenuItem>
                      <MenuItem value={'10:30'}>10:30</MenuItem>
                      <MenuItem value={'11:00'}>11:00</MenuItem>
                      <MenuItem value={'11:30'}>11:30</MenuItem>
                      <MenuItem value={'12:00'}>12:00</MenuItem>
                      <MenuItem value={'12:30'}>12:30</MenuItem>
                      <MenuItem value={'13:00'}>13:00</MenuItem>
                      <MenuItem value={'13:30'}>13:30</MenuItem>
                      <MenuItem value={'14:00'}>14:00</MenuItem>
                      <MenuItem value={'14:30'}>14:30</MenuItem>
                      <MenuItem value={'15:00'}>15:00</MenuItem>
                      <MenuItem value={'15:30'}>15:30</MenuItem>
                      <MenuItem value={'16:00'}>16:00</MenuItem>
                      <MenuItem value={'16:30'}>16:30</MenuItem>
                      <MenuItem value={'17:00'}>17:00</MenuItem>
                      <MenuItem value={'17:30'}>17:30</MenuItem>
                      <MenuItem value={'18:00'}>18:00</MenuItem>
                      <MenuItem value={'18:30'}>18:30</MenuItem>
                      <MenuItem value={'19:00'}>19:00</MenuItem>
                      <MenuItem value={'19:30'}>19:30</MenuItem>
                      <MenuItem value={'20:00'}>20:00</MenuItem>
                      <MenuItem value={'20:30'}>20:30</MenuItem>
                      <MenuItem value={'21:00'}>21:00</MenuItem>
                      <MenuItem value={'21:30'}>21:30</MenuItem>
                      <MenuItem value={'22:00'}>22:00</MenuItem>
                      <MenuItem value={'22:30'}>22:30</MenuItem>
                      <MenuItem value={'23:00'}>23:00</MenuItem>
                      <MenuItem value={'23:30'}>23:30</MenuItem>
                    </TextField>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box ml={6} fontSize={12}>
                  Vrsta rada:
                </Box>
                <Box ml={6}>
                  <Box className={classes.columnRoot}>
                    <TextField
                      id="type"
                      name="type"
                      margin="small"
                      select
                      defaultValue=""
                      value={this.state.type}
                      style={{ marginLeft: 20 }}
                      onChange={event => this.handleChange('type', event.target.value)}>
                      <MenuItem value={0}>redovni rad</MenuItem>
                      <MenuItem value={1}>bolovanje</MenuItem>
                      <MenuItem value={2}>godišnji odmor</MenuItem>
                    </TextField>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Button variant="contained" color="primary" className={classes.myButton} onClick={() => this.handleClose()}>
              Zatvori
            </Button>
            <Button variant="contained" color="primary" className={classes.myButton} onClick={() => this.handleSave()}>
              Promijeni
            </Button>
          </Box>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(ViewEvent));
